module.exports = __webpack_public_path__ + "static/media/footer_2.8a771514.png";